import MarkdownIt from "markdown-it";
import anchor from "markdown-it-anchor";

const images = require.context(
  "@/assets/docs/ca2-user-manual/manual-images",
  false,
  /\.(png|jpe?g|gif|svg)$/
);

const imageMap = {};

images.keys().forEach((key) => {
  const filename = key.replace("./", "");
  imageMap[`./manual-images/${filename}`] = images(key);
});

function resolveImagePath(path) {
  return imageMap[path] || path;
}

function imagePlugin(md) {
  const defaultImage =
    md.renderer.rules.image ||
    function(tokens, idx, options, _, self) {
      return self.renderToken(tokens, idx, options);
    };

  md.renderer.rules.image = function(tokens, idx, options, env, self) {
    const token = tokens[idx];
    const src = token.attrGet("src");

    if (src && !src.startsWith("http") && !src.startsWith("/")) {
      const resolved = resolveImagePath(src);
      token.attrSet("src", resolved);
    }

    return defaultImage(tokens, idx, options, env, self);
  };
}

function mermaidPlugin(md) {
  const defaultRender =
    md.renderer.rules.fence ||
    function(tokens, idx, options, _, renderer) {
      return renderer.renderToken(tokens, idx, options);
    };

  let idCounter = 0;

  md.renderer.rules.fence = function(tokens, idx, options, env, self) {
    const token = tokens[idx];
    const info = token.info ? token.info.trim() : "";

    if (info === "mermaid") {
      const id = `mermaid-${idCounter++}`;
      const code = token.content.trim();
      return `<pre id="${id}" class="mermaid">${code}</pre>`;
    }

    return defaultRender(tokens, idx, options, env, self);
  };
}

const md = new MarkdownIt({
  breaks: true,
  html: true,
  linkify: true,
  typographer: true,
})
  .use(anchor, {
    slugify: (s) =>
      s
        .trim()
        .toLowerCase()
        .replace(/[^\w]+/g, "-")
        .replace(/[^\d-]+/g, "")
        .replace(/^-+|-+$/g, ""),
  })
  .use(imagePlugin)
  .use(mermaidPlugin);

export function renderMarkdown(raw) {
  return md.render(raw);
}
